/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileOptionDto
 */
export interface ProfileOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileOptionDto
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileOptionDto
     */
    profileName?: string;
}

/**
 * Check if a given object implements the ProfileOptionDto interface.
 */
export function instanceOfProfileOptionDto(value: object): value is ProfileOptionDto {
    return true;
}

export function ProfileOptionDtoFromJSON(json: any): ProfileOptionDto {
    return ProfileOptionDtoFromJSONTyped(json, false);
}

export function ProfileOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'profileName': json['profileName'] == null ? undefined : json['profileName'],
    };
}

export function ProfileOptionDtoToJSON(json: any): ProfileOptionDto {
    return ProfileOptionDtoToJSONTyped(json, false);
}

export function ProfileOptionDtoToJSONTyped(value?: ProfileOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profileId': value['profileId'],
        'profileName': value['profileName'],
    };
}

